import { useState, useEffect } from 'react';
import { WhatsappLogo } from '@phosphor-icons/react';
import { motion, AnimatePresence } from 'framer-motion';
import { publicApi } from '../lib/api';

export const WhatsAppFloatingButton = () => {
  const [settings, setSettings] = useState(null);
  const [isVisible, setIsVisible] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    publicApi.getSettings().then(res => setSettings(res.data)).catch(() => {});
    
    // Show button after scrolling a bit
    const handleScroll = () => {
      setIsVisible(window.scrollY > 300);
    };
    
    window.addEventListener('scroll', handleScroll);
    // Show immediately after 2 seconds if not scrolled
    const timer = setTimeout(() => setIsVisible(true), 2000);
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
      clearTimeout(timer);
    };
  }, []);

  const whatsappNumber = settings?.contact?.whatsapp?.replace(/\D/g, '') || '18091234567';
  const message = '¡Hola! Me interesa información sobre sus excursiones en República Dominicana.';
  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ scale: 0, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0, opacity: 0 }}
          transition={{ type: "spring", stiffness: 260, damping: 20 }}
          className="fixed bottom-6 right-6 z-50"
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
        >
          {/* Tooltip */}
          <AnimatePresence>
            {showTooltip && (
              <motion.div
                initial={{ opacity: 0, x: 10 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: 10 }}
                className="absolute right-full mr-3 top-1/2 -translate-y-1/2 whitespace-nowrap"
              >
                <div className="bg-white px-4 py-2 rounded-xl shadow-lg text-sm font-medium text-[#012A36]">
                  ¿Necesitas ayuda? ¡Escríbenos!
                </div>
              </motion.div>
            )}
          </AnimatePresence>

          {/* Button */}
          <a
            href={whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="whatsapp-floating-btn"
          >
            <motion.button
              className="w-16 h-16 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-lg"
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.95 }}
              style={{
                boxShadow: '0 4px 20px rgba(37, 211, 102, 0.5)'
              }}
            >
              <WhatsappLogo weight="fill" className="w-8 h-8" />
            </motion.button>
          </a>

          {/* Pulse animation */}
          <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-30 pointer-events-none" />
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default WhatsAppFloatingButton;
